// extracted by css-extract-rspack-plugin
export default {"MarketingPill":"sputnik__MarketingPill__yfyiB","marketingPill":"sputnik__MarketingPill__yfyiB"};